import { render } from "./Segments.vue?vue&type=template&id=36987815&scoped=true"
import script from "./Segments.vue?vue&type=script&lang=js"
export * from "./Segments.vue?vue&type=script&lang=js"

import "./Segments.vue?vue&type=style&index=0&id=36987815&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36987815"]])

export default __exports__